import React, { useContext } from 'react';
import { useTheme  } from '@emotion/react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite/no-important';
import { ThemeContext } from '../../theme';

const propTypes = {
  type: PropTypes.oneOf(['text', 'password']),
  value: PropTypes.string,
  placeholder: PropTypes.string,
  dataAttributeValue: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onKeyUp: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func
};

const defaultProps = {
  type: 'text',
  placeholder: '',
  value: '',
  style: {},
  disabled: false,
  className: '',
  onChange: () => {},
  onClick: () => {},
  onKeyUp: () => {},
  onBlur: () => {},
  onFocus: () => {}
};

const TextInput = (props) => {
  const context = useContext(ThemeContext);
  const theme = useTheme();
  let textInput;
  if (theme && theme.textInput) {
    textInput = theme.textInput;
  } else {
    textInput = context.theme.textInput;
  }
  const {
    background,
    color,
    placeholderColor,
    caretColor,
    fontWeight,
    fontSize,
    padding
  } = textInput;

  const {
    type,
    placeholder,
    value,
    className,
    style,
    dataAttributeValue,
    disabled
  } = props;

  const styles = StyleSheet.create({
    input: {
      border: '0',
      background: background,
      color: color,
      caretColor: caretColor,
      padding: padding,
      width: '120px',
      height: 32,
      textAlign: 'left',
      borderRadius: 0,
      fontWeight,
      fontFamily: 'inherit',
      fontSize,
      ':focus': {
        outline: 'none'
      },
      '::placeholder': {
        color: placeholderColor
      }
    }
  });

  return (
    <input
      type={type}
      value={value}
      data={dataAttributeValue}
      placeholder={placeholder}
      className={`${className} ${css(styles.input)}`}
      style={{ ...style }}
      disabled={disabled}
      autoCorrect='off'
      autoCapitalize='none'
      onChange={props.onChange}
      onClick={props.onClick}
      onBlur={props.onBlur}
      onFocus={props.onFocus}
    />
  );
};

TextInput.propTypes = propTypes;
TextInput.defaultProps = defaultProps;

export { TextInput };
